import { gql } from '@apollo/client'
import { EHR_APPOINTMENT_ATTENDANCE_FIELDS } from './ehrAppointmentAttendance'

export const EHR_APPOINTMENT_FIELDS = gql`
  ${EHR_APPOINTMENT_ATTENDANCE_FIELDS}
  fragment EhrAppointmentFields on EhrAppointment {
    id
    getHealthieId
    category
    coachingKind
    kind
    meetingAt
    title
    getHealthieInstanceKind
    startUrl
    joinUrl
    addToGcalLink
    unauthenticatedIcsLink
    noShowFeeProduct
    lateCancellationFeeProduct
    lateRescheduleFeeProduct
    forbidLateReschedule
    lastState {
      reason
      kind
      terminal
    }
    updatedAt
    providerName
    recurring
    attendances {
      ...EhrAppointmentAttendanceFields
    }
    providers {
      coach {
        id
        fullName
        coachId
        photo
      }
    }
  }
`
